module.exports = __webpack_public_path__ + "static/media/Velocity chart.86033e5d.svg";